import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import * as React from "react";

export interface RangeSliderValue {
  min: number;
  max: number;
}

export interface RangeSliderProps {
  value: RangeSliderValue;
  min: number;
  max: number;
  currency?: string;
  cb: (val: RangeSliderValue) => void;
}

export const RangeSlider: React.FunctionComponent<RangeSliderProps> = (props) => {
  let marks;
  if (props.currency) {
    marks = {
      [props.value.min]: `${props.currency} ${props.value.min}`,
      [props.value.max]: `${props.currency} $${props.value.max}`,
    };
  } else {
    marks = {
      [props.value.min]: `${props.value.min}`,
      [props.value.max]: `${props.value.max}`,
    };
  }
  return (
    <Slider
      marks={marks}
      allowCross={false}
      range={true}
      min={props.min}
      max={props.max}
      value={[props.value.min, props.value.max]}
      onChange={(changed: number | number[]): void => {
        const min = (changed as number[])[0];
        const max = (changed as number[])[1];
        props.cb({ min, max });
      }}
    />
  );
};
